import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, IconButton, Tooltip, Typography } from '@mui/material';
import SearchRounded from '@mui/icons-material/SearchRounded';
import { useAuth } from '../context/AuthContext';
import GlobalSearchDialog from './GlobalSearchDialog';

function Launcher({ compact }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const shortcut = event => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k' && !document.querySelector('[role="dialog"]')) { event.preventDefault(); setOpen(true); }
    };
    window.addEventListener('keydown', shortcut); return () => window.removeEventListener('keydown', shortcut);
  }, []);
  return <>
    {compact ? <Tooltip title="Buscar en el sistema"><IconButton onClick={() => setOpen(true)} aria-label="Buscar en el sistema" sx={{ width: 44, height: 44 }}><SearchRounded fontSize="small" /></IconButton></Tooltip>
      : <ButtonBase onClick={() => setOpen(true)} aria-label="Buscar en el sistema" sx={{ minHeight: 44, px: 1.5, gap: 1, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}><SearchRounded fontSize="small" /><Typography variant="body2">Buscar registros…</Typography><Box component="kbd" sx={{ color: 'text.secondary', fontSize: 11 }}>⌘ / Ctrl K</Box></ButtonBase>}
    <GlobalSearchDialog open={open} onClose={() => setOpen(false)} />
  </>;
}
export default function GlobalSearchLauncher({ compact = false }) {
  const { user } = useAuth();
  return user ? <Launcher key={user.id} compact={compact} /> : null;
}
